
import {useDates} from '../Hooks/Dates';
import logo from '../logo_iac.svg';

import InfoCard from './InfoCard';
import VerticalNavbar from './Sidebar';

import { Link } from "react-router";


function Header() {

  const dates = useDates();

  return (
    <header>
        <div className="row gx-1">
          <div className="col-6 ps-3">
               <Link to={{ pathname: "/"}} className='text-light' title='Meteo Dashboard'>
                  <img src={logo} className='text-light' alt="IAC logo" id="iac_logo" />
                   <span id="site-title" class="d-none d-sm-inline">
                    Observatorio del Teide Meteorology
                  </span>
                  <span id="site-title" class="d-inline d-sm-none">
                   OTmeteo
                  </span>
               </Link>
          </div>
          <div className="col-6 d-flex justify-content-end" style={{ height: '1.7em' }}>
              <InfoCard label="LT" title="Local time (OT)" value={dates.local_time}  variant='bg-teal' inline='True' />
              <InfoCard label="UTC" title="Universal Time Coordinated" value={dates.utc} variant='bg-teal' inline='True' />
              <InfoCard label="LST" title="Local Sidereal time (OT)" value={dates.lst}  variant='bg-teal' inline='True'/>
              <VerticalNavbar />
          </div>
        </div>
    </header>
  );
}

export default Header;